import { render } from "./AsignaturaDropdown.vue?vue&type=template&id=00674637&scoped=true"
import script from "./AsignaturaDropdown.vue?vue&type=script&lang=js"
export * from "./AsignaturaDropdown.vue?vue&type=script&lang=js"

import "./AsignaturaDropdown.vue?vue&type=style&index=0&id=00674637&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00674637"]])

export default __exports__